import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';

import { FooterApp } from './FooterApp';
import { NavbarV2 } from './NavbarV2';
import { SiderApp } from './SiderApp';

import toggleDrawer from 'utils/toggleDrawer';

import './styles.scss';

// Pages that already center their own content with max-width: $container-size
// (matching the navbar's own max-width), so the wrapper's lateral padding
// below just doubles into an oversized, off-center gutter. Only the home
// page still needs that padding (its full-bleed hero sections rely on it).
const FULL_BLEED_EXACT_ROUTES = [
  '/guide/register',
  '/chat',
  '/profile',
  '/advisor/profile',
  '/about-us',
  '/terms-and-conditions',
  '/privacy-policy',
  '/search-travel-expert',
  '/testimonials',
  '/register',
  '/history-calls',
  '/travel-expert/complete-profile',
];

const FULL_BLEED_ROUTE_PREFIXES = [
  '/briefing',
  '/advisor/briefing',
  '/advisor-details',
  '/resume',
  '/advisor/resume',
  '/advisor/meeting-resume',
  '/admin',
  '/traveler-log',
  '/advisor/traveler-log',
  '/b2b/admin',
  '/b2b/agent',
  '/meet',
  '/lobby',
];

function isFullBleedPage(pathname) {
  return (
    FULL_BLEED_EXACT_ROUTES.includes(pathname) ||
    FULL_BLEED_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix))
  );
}

// O painel admin usa a largura toda da janela; a navbar acompanha para o logo
// nao ficar recuado enquanto o conteudo comeca na borda.
function isAdminPanel(pathname) {
  return pathname === '/admin' || pathname.startsWith('/admin/');
}

export function ContainerApp({ children, hasBgImg = false }) {
  const { pathname } = useLocation();

  const isRegisterPage = pathname === '/guide/register';
  const isMeetingsPage =
    pathname.startsWith('/meet') || pathname.startsWith('/lobby');
  const isChatPage = pathname === '/chat';
  const isBriefingPage = pathname.startsWith('/briefing');
  // The admin is a work tool: the marketing footer (addresses, newsletter
  // sign-up) is noise under a data table.
  const canShowFooter =
    !isRegisterPage &&
    !isMeetingsPage &&
    !isChatPage &&
    !isBriefingPage &&
    !isAdminPanel(pathname);

  return (
    <Layout>
      <SiderApp />

      <div
        className={`container-app ${hasBgImg ? 'has-bg-img' : ''} ${
          isFullBleedPage(pathname) ? '' : 'not-register'
        } ${isAdminPanel(pathname) ? 'is-admin-panel' : ''}`}
      >
        <NavbarV2 showDrawer={toggleDrawer} />
        <main className="container-app__wrapper">{children}</main>
      </div>

      {canShowFooter && <FooterApp />}
    </Layout>
  );
}
